{
  "shared-user-preferences-onboarding.modal.alternative-text": [
    {
      "type": 0,
      "value": "Alternatively, you can choose light or dark mode from the "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Appearance"
        }
      ],
      "type": 8,
      "value": "appearanceSettings"
    },
    {
      "type": 0,
      "value": " settings in your profile menu."
    }
  ],
  "shared-user-preferences-onboarding.modal.button.accept": [
    {
      "type": 0,
      "value": "Okay"
    }
  ],
  "shared-user-preferences-onboarding.modal.button.choose-theme": [
    {
      "type": 0,
      "value": "Choose mode"
    }
  ],
  "shared-user-preferences-onboarding.modal.description": [
    {
      "type": 0,
      "value": "All supported apps will now match your system's display mode by default."
    }
  ],
  "shared-user-preferences-onboarding.modal.feature.consistent": [
    {
      "type": 0,
      "value": "Consistent look and feel"
    }
  ],
  "shared-user-preferences-onboarding.modal.feature.override": [
    {
      "type": 0,
      "value": "Choose display mode for individual apps"
    }
  ],
  "shared-user-preferences-onboarding.modal.feature.set-once": [
    {
      "type": 0,
      "value": "Only set your display mode once"
    }
  ],
  "shared-user-preferences-onboarding.modal.title": [
    {
      "type": 0,
      "value": "Your display mode is now synced"
    }
  ]
}